import { render, staticRenderFns } from "./uploadPicThumb.vue?vue&type=template&id=0878d26c&"
import script from "./uploadPicThumb.vue?vue&type=script&lang=js&"
export * from "./uploadPicThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports